exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "main[data-v-3c55e77d]{min-height:50vh}", ""]);

